import React from "react";
import { Box, Typography } from "@material-ui/core";
import useStyles from "./styles";
import { getCheckPaymentPs } from '../../utils/productUtils';

const PurchaseSummary = ({
  selectedFlight,
  travelCareValue,
  tipsValue,
  acceptTipsValue,
  manualSplitValue
}) => {
  const {
    summaryModal,
    descriptionEl,
    totalSummary,
    mainSummary,
  } = useStyles();

  const inhouseCharge = () => {
    const ckPs = getCheckPaymentPs( selectedFlight ) + 1
    const {tbc, airline} = selectedFlight.taxes

    return manualSplitValue ? tbc + airline * ckPs : tbc
  }

  const airlineCharge = () => {
    const {tbc, airline} = selectedFlight.taxes

    return manualSplitValue ? 0 : airline
  }

  const priceOfferCalc = () => {
    return inhouseCharge() + airlineCharge()
  }

  const totalPriceCalc = () => {
    let price = priceOfferCalc()
    if (travelCareValue === "applyProtection") {
      price = price + selectedFlight?.travelCarePrice;
    }
    if (acceptTipsValue) {
      price = price + Number(tipsValue);
    }
    return price.toFixed(2);
  };

  return (
    <Box className={summaryModal}>
      <Box className={mainSummary}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          className={descriptionEl}
        >
          <Typography>Air Tickets</Typography>
          <Typography variant="subtitle1">{`$ ${priceOfferCalc().toFixed(
            2
          )}`}</Typography>
        </Box>
        {selectedFlight?.accomodation && (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            className={descriptionEl}
          >
            <Typography>Hotel</Typography>
            <Typography variant="subtitle1">{`$ ${selectedFlight?.accomodation?.price.toFixed(
              2
            )}`}</Typography>
          </Box>
        )}
        {travelCareValue === "applyProtection" && (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            className={descriptionEl}
          >
            <Typography>Travel Care</Typography>
            <Typography variant="subtitle1">{`$ ${selectedFlight?.travelCarePrice.toFixed(
              2
            )}`}</Typography>
          </Box>
        )}
        {acceptTipsValue && (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            className={descriptionEl}
          >
            <Typography>Tips Value</Typography>
            <Typography variant="subtitle1">{`$ ${Number(tipsValue).toFixed(
              2
            )}`}</Typography>
          </Box>
        )}
      </Box>
      <Box className={totalSummary}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          className={descriptionEl}
        >
          <Typography>TOTAL</Typography>
          <Typography variant="h4">{`$ ${totalPriceCalc()}`}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default PurchaseSummary;
